import {DebugPanel, makePersistent, Storage} from '@wix/debug-panel';
import {WixSdk} from '@wix/js-sdk-wrapper';
import {getAppVersion} from '@wix/music-shared/dist/src/wmp-shared/utils/env/getAppVersion';
import {Settings} from './Settings';

export const settings: Settings = makePersistent(new Settings(), new Storage('getWindow'));

export const debugPanel = new DebugPanel(settings, {
  version: getAppVersion(),
  info: [
    {
      title: 'MSID',
      value: WixSdk.Utils.getInstanceValue('metaSiteId'),
    },
    {
      title: 'AppDefId',
      value: WixSdk.Utils.getInstanceValue('appDefId'),
    },
  ],
});
